import React, { ReactNode } from 'react'
import { HeaderRightContainerStyles } from './styles'

const HeaderRightContainer = ({
  childOne,
  childTwo
}: {
  childOne: ReactNode
  childTwo?: ReactNode
}) => {
  const classes = HeaderRightContainerStyles()
  return (
    <div className={classes.container}>
      {childOne}
      {childTwo && childTwo}
    </div>
  )
}

export default HeaderRightContainer
